export default {
  state: () => ({
    biometricsEntered: false,
    biometricsSchema: [],
    codesent: false,
    formData: {},
    longFormHtml: {},
    multiTextVals: [],
    multiTextValues: [{}],
    resendCodeSchema: [],
    signedUp: false,
    signUpSchema: [],
    verified: false,
    verificationSchema: [],
    availablePlans: [],
    selectedPlan: null,
    verifyError: ''
  })
}



// WEBPACK FOOTER //
// ./src/app/store/signup/config.js